export default __webpack_public_path__ + "images/3G.b177053.png";